import type { SVGProps } from 'react';

const LayerSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      d="M15 20V26L5 20V14L15 20ZM27 20L17 26V20L27 14V20ZM26 12.0039L16.0039 18L6 12.0039L15.9961 6L26 12.0039Z"
      fill="currentColor"
    />
  </svg>
);
export default LayerSvgIcon;
